/* eslint-disable array-callback-return */
import { FrameType, IImageData } from './types';

const decideFrameType = (images: Array <IImageData>): FrameType => {
  let potrait = 0;
  let square = 0;
  images.map((image) => {
    if (image.frame_type === 'FRAME_TYPE_PORTRAIT') {
      potrait += 1;
    } else if (image.frame_type === 'FRAME_TYPE_SQUARE') {
      square += 1;
    }
  });

  if (potrait > 0) {
    return 'FRAME_TYPE_PORTRAIT';
  }
  if (square > 0) {
    return 'FRAME_TYPE_SQUARE';
  }
  return 'FRAME_TYPE_LANDSCAPE';
};

const getFileExtension = (url: string): string => {
  const exts = url.split('.');
  
  if (exts.length > 1) {
    return exts.pop();
  }
  return '';
};

export {
  decideFrameType,
  getFileExtension,
};
